import React from "react";
import {useDispatch, useSelector} from "react-redux";
import { Modal, ModalHeader, ModalContent, ModalFooter, Notification, Button, StyledLink, Text, ExternalLink } from "@netapp/bxp-design-system-react";
import { useTranslation, Trans } from 'react-i18next';
import { appComponents as i18nNamespace } from '../../../i18n/namespace';
import { AGENT_TROUBLESHOOTING_GUIDE_URL } from "utils/app/constants";

export default () => {
    const dispatch = useDispatch();
    const { t } = useTranslation(i18nNamespace);
    const selectedAgentId = useSelector(state => state.tenancy.selectedAgentId);

    const discardChangeAgentDialog = () => {
        dispatch({
            type: 'TENANCY:DISCARD-CHANGE-AGENT-MESSAGE'
        })
    };

    const openConnectorMenu = () => {
        discardChangeAgentDialog();

        dispatch({
            type: 'MENU:OPEN-WIDGET',
            payload: 'connectors'
        });
    };
    
    return <Modal>
        <ModalHeader>
            {t("inactive_connector")}
        </ModalHeader>
        <ModalContent>
            <Notification type="error" style={{marginBottom: 35}}>
               {t("connector_inactive_error")}
            </Notification>
            {selectedAgentId && <>
                <Text>
                    <Trans 
                        i18nKey="check_network_connectivity" 
                        t={t} 
                        components={{ 
                            learnMoreLink: <ExternalLink variant="text" href={AGENT_TROUBLESHOOTING_GUIDE_URL} />
                        }} 
                    />
                </Text>
                <Text>{t("switched_to_active_connector")}</Text>
            </>}
            {!selectedAgentId && (
                <Text>
                    <Trans 
                        i18nKey="check_and_create_new_connector" 
                        t={t} 
                        components={{ 
                            learnMoreLink: <ExternalLink variant="text" href={AGENT_TROUBLESHOOTING_GUIDE_URL} />
                        }} 
                    />
                </Text>
            )}
        </ModalContent>
        <ModalFooter>
            {selectedAgentId && <Button onClick={openConnectorMenu}>{t("switch_bluexp_connectors")}</Button>}
            {!selectedAgentId && <StyledLink to={location => ({...location, hash: "addConnector"})} onClick={discardChangeAgentDialog}>{t("create_connector")}</StyledLink>}
            <Button color="secondary" onClick={discardChangeAgentDialog}>{t("close")}</Button>
        </ModalFooter>
    </Modal>;
};
